<template>
  <FlexboxLayout class="list" flexWrap="wrap">
    <StackLayout v-for="(entry, index) in entriesFiltered" :key="index">
      <Label class="title" :text="entry.title" textWrap />
      <GridLayout class="action" columns="*, 40" v-if="entry.action" justifyContent="space-between" @tap="entry.action" @click="entry.action">
        <Label col="0" class="text" :text="entry.text" textWrap />
        <AgIcon col="1" :type="entry.icon || 'chevronRight'" />
      </GridLayout>
      <Label v-else class="text" :text="entry.text" textWrap />
    </StackLayout>
  </FlexboxLayout>
</template>

<script>

export default {
  props: {
    entries: {
      type: Array,
      default () {
        return []
      }
    }
  },
  computed: {
    entriesFiltered () {
      return this.entries.filter(entry => !entry.condition || entry.condition())
    }
  }
}

</script>

<style scoped lang="scss">

.list {
  background-color: #eee;
}

.list > * {
  width: 100%;
}

.list .text {
  color: #004e9e;
}

.ns-ios,
.ns-android {
  .list {
    padding-top: 20;
    padding-bottom: 0;
    border-radius: 6;
  }

  .list > * {
    margin: 0 0 20 0;
    padding: 0 20;
  }

  .list .title {
    font-size: 14;
    margin: 0 0 5 0;
  }

  .list .text {
    font-size: 18;
  }

  &.ns-ios .list .text {
    font-size: 23;
  }
}

html {
  .list {
    padding-top: 20px;
    border-radius: 6px;
  }

  .list > * {
    margin: 0 0 20px 0;
    padding: 0 20px;
  }

  .list .title {
    font-size: 14px;
    margin: 0 0 5px 0;
  }

  .list .text {
    font-size: 18px;
  }

  .list .action {
    cursor: pointer;
  }

  @media (min-width: 600px) {
    .list > * {
      width: 40%;
      flex-grow: 1;
    }

    .list > :nth-child(odd) {
      margin-right: 10px;
    }

    .list > :last-child:nth-child(odd) {
      margin-right: 0;
    }

    .list > :nth-child(even) {
      margin-left: 10px;
    }
  }
}

</style>